import { Button } from '@edsn/pie-components';
import infoIcon from '@iconify/icons-material-symbols/info-outline';
import { type ComponentProps, useState } from 'react';
import { Icon } from '../icon/Icon';
import { Dialog } from '../layout/dialog/Dialog';
import type { Tooltip } from '../tooltip/Tooltip';

interface Props
  extends Omit<ComponentProps<typeof Tooltip>, 'children' | 'message'>,
    Pick<ComponentProps<typeof Dialog>, 'title'> {
  children: string;
}

export const InfoDialog = ({ children, title }: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        action="tertiary"
        emphasis="minimal"
        iconStart={<Icon icon={infoIcon} size={16} />}
        onClick={() => setOpen(true)}
        size="sm"
        className="p-0"
      />

      <Dialog title={title} open={open} onOpenChange={setOpen}>
        {children}
      </Dialog>
    </>
  );
};
